// import {DropDown} from "./components/DropDown/DropDown";
// import {NAV_LINK_1, NAV_LINK_2, NAV_LINK_3} from "../../constants";
import styles from './Navbar.module.scss';
import Link from 'next/link';

export const Navbar = () => {
  return (
    <nav className={styles.nav}>
      <div className={styles.desktop}>
        <div className={styles.drop}>
          {/*<DropDown label={"Деятельность"} items={NAV_LINK_1}/>*/}
          {/*<DropDown label={"Об организации"} items={NAV_LINK_2}/>*/}
          {/*<DropDown label={"Учебный центр"} items={NAV_LINK_3}/>*/}
          <Link href={'/services'}>
            Услуги
          </Link>
          <Link href={'/training'}>
            Учебный центр
          </Link>
          <Link href={'/events'}>
            Курсы и мероприятия
          </Link>
          <Link href={'/announcements'}>
            Анонсы
          </Link>
          <Link href={'/about'}>
            О нас
          </Link>
          <Link href={'/news'}>
            Новости
          </Link>
        </div>

        <div className={styles.links}>
          <Link href={'https://xn--80acmlhv0b.xn----7sbbcf5aipa3c3b.xn--p1ai/'}>
            <div
              className={styles.button}
              style={{
                border: '2px solid #292929',
                fontWeight: '500',
              }}
            >
              Личный кабинет
            </div>
          </Link>
        </div>
      </div>
    </nav>
  );
};
